import React from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemText } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  Character,
  Campaign,
} from "@dndModels";

import { makeStyles } from "@utilities/theme_utilities";
import DandDAPI from '@utilities/smart_api';

interface Props { 
  character: Character;
  campaign: Campaign;
}

const api = DandDAPI.getInstance();

export default function CharacterCampaignInfo({ 
  character, 
  campaign, 
}: Props) {

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        textDecoration: "none"
      },
    });
  });
  const { classes, cx } = useStyles();

  const renderCharacters = () => {
    return campaign.characters.filter(o => o.active && !o.is_archived && o._id !== character._id && o.c_char && 
      ((!o.c_char.hide_char && !o.c_char.hide_details) || o.owner_id === api.user_id || campaign.owner_id === api.user_id)
    ).map(char => {
      const owner = campaign.players.find(o => o._id === char.owner_id);
      return (
        <Grid key={char._id} container spacing={0} direction="row">
          <Grid size={12}>
            <ListItem className="curvedButton">
              <NavLink to={`/character/${char._id}`} target="_blank" rel="noopener noreferrer"
                className={cx(classes.root, "MyButton")}>
                <ListItemText primary={char.name} className="marginLeft" />
              </NavLink>
            </ListItem>
          </Grid>
          { owner && 
            <Grid size={12} className="small_label gray">
              { owner.profile_name }
            </Grid>
          }
        </Grid>
      );
    });
  }
  
  // if (!fetched || loading) {
  //   return (<LoadingBox />);
  // } else {
    return (
      <div style={{ 
        height: "100%",
        overflowX: "hidden"
      }}>
        <Grid container spacing={0} direction="row">
          <Grid size={12}>
            <ListItem className="curvedButton">
              <NavLink to={`/campaign/${campaign._id}`} target="_blank" 
                className={cx(classes.root, "MyButton")}>
                <ListItemText primary={`Campaign: ${campaign.name}`} className="marginLeft" />
              </NavLink>
            </ListItem>
          </Grid>
          { renderCharacters() }
        </Grid>
      </div>
    );
  // }
}

